import LogoDark from "@/assets/images/allears-dark.svg";
import { cx } from "@/utils";

import styles from "./PublicLayout.module.css";

const PublicLayout: React.FunctionComponent<
  React.HTMLProps<HTMLDivElement> & {
    menu?: React.ReactNode;
    navClassName?: string;
    variant?: "white" | "gray";
  }
> = ({ children, menu, className, navClassName, variant = "white" }) => {
  return (
    <>
      <nav className={cx(styles.navigation, navClassName)}>
        <a href="/">
          <LogoDark alt="All Ears" width="135" />
        </a>
        {menu && <div className={styles.menu}>{menu}</div>}
      </nav>
      <main
        className={cx(
          styles.main,
          { [styles.gray]: variant === "gray" },
          className
        )}
      >
        {children}
      </main>
    </>
  );
};
export default PublicLayout;
